import { AppLocale } from 'constant';
import { Dvd } from 'interfaces';

import dvdsDataRaw from 'data/dvds.json';

const dvdsData: Dvd[] = dvdsDataRaw as unknown as Dvd[];

export const getDvd = (dvdId, locale = AppLocale.EN, field: 'name' | 'link' = 'name') => {
  const dvd = dvdsData.filter((album) => album.id === dvdId)[0];

  switch (field) {
    case 'name': {
      return locale === AppLocale.EN ? dvd?.englishName || dvd.name : dvd.name;
    }
    case 'link': {
      return `/dvds/${dvd.id}`;
    }
  }
}
